import React, { Component } from "react";
import { CallAPI, GetCookieFunction } from '../../utils/util';

class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePatients: "—",
            activeStaff: "—"
        };
    }

    componentDidMount() {
        const centerId = GetCookieFunction("Center").id;
        CallAPI({}, `admin/reports?centerId=${centerId}`, 'GET', (res) => {
            this.setState({
                activePatients: res.activePatients,
                activeStaff: res.activeStaff
            });
        });
    }

    render() {
        return (
            <div className="ci-page">
                <div className="ci-header">
                    <h2>Reports</h2>
                    <p>System overview and statistics</p>
                </div>

                <div className="stats-row">
                    <div className="stat-card green">
                        <div className="stat-value">{this.state.activePatients}</div>
                        <div className="stat-label">Active Patients</div>
                    </div>
                    <div className="stat-card yellow">
                        <div className="stat-value">{this.state.activeStaff}</div>
                        <div className="stat-label">Active Staff</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Reports;
